import React from 'react';

/**
 * ErrorBoundary - contains render errors in its subtree (e.g. an agent-generated
 * dashboard whose JSON doesn't match the expected shape) so a bad payload shows a
 * local message instead of unmounting the whole app.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error">
          {this.props.message || 'Something went wrong displaying this section.'}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
